import React, { ReactNode, useCallback, useLayoutEffect, useRef, useState } from 'react';

import { Container } from './read-more-accordion.styled';
import { ReadMoreButton } from './read-more-button';

export const ReadMoreAccordion = ({ children }: { children: ReactNode }) => {
  const descriptionRef = useRef<HTMLDivElement>(null);
  const [shouldDisplayReadMoreBtn, setShouldDisplayReadMoreBtn] = useState<boolean>(false);
  const [descriptionIsCollapsed, setDescriptionIsCollapsed] = useState<boolean>(true);

  const toggleAccordion = useCallback(() => {
    setDescriptionIsCollapsed(!descriptionIsCollapsed);
  }, [descriptionIsCollapsed]);

  useLayoutEffect(() => {
    const { current } = descriptionRef;
    let resizeObserver: ResizeObserver | undefined;

    if (current) {
      const handleShouldDisplayReadMoreBtn = () => {
        const descriptionIsExpanded = !descriptionIsCollapsed;
        const hasOverflow = descriptionIsExpanded || current.scrollHeight > current.clientHeight;
        setShouldDisplayReadMoreBtn(hasOverflow);
      };
      if ('ResizeObserver' in window) {
        resizeObserver = new window.ResizeObserver(handleShouldDisplayReadMoreBtn).observe(current);
      }
      handleShouldDisplayReadMoreBtn();
    }

    return () => {
      if (current && resizeObserver) {
        resizeObserver.unobserve(current);
      }
    };
  }, [descriptionIsCollapsed]);

  const accordionContentId = 'accordion-content';
  return (
    <>
      <Container
        id={accordionContentId}
        $collapsed={descriptionIsCollapsed}
        ref={descriptionRef}
        tabIndex={0}
      >
        {children}
      </Container>

      {shouldDisplayReadMoreBtn && (
        <ReadMoreButton
          collapsed={descriptionIsCollapsed}
          cta={toggleAccordion}
          aria-controls={accordionContentId}
        />
      )}
    </>
  );
};
